<template>
  <div>
    <relation-input
        v-model="option.value"
        :option-id="option.fillContext[0].id"
        :question-id="questionId"
        :question-type="questionType"
        :enable-relation="enableRelation"
        :disable-copy="disableCopy"
        :readonly="option.readonly"
    />
    <template v-if="errorText">
      <div class="text-danger mt-1">
        <span>{{errorText}}</span>
      </div>
    </template>
  </div>
  <!--  <el-input placeholder="请输入" v-model="option.value"></el-input>-->
</template>

<script>
import RelationInput from '@/questions/components/RelationInput'

export default {
  name: 'Fill',
  components: { RelationInput },
  props: {
    option: {
      type: Object,
      default: () => ({})
    },
    questionId: {
      type: String,
      default: ''
    },
    questionType: {
      type: Number
    },
    enableRelation: {
      type: Boolean,
      default: false
    },
    disableCopy: {
      type: Boolean,
      default: false
    },
    question:{
      type: Object,
      default: () => ({})
    }
  },
  computed:{
    errorText(){
      const key = `${this.question.id}.${this.option.rowId}.${this.option.colId}`
      return this.question.questionErrorList.find(i=>i.key===key)?.message
    }
  }
}
</script>
